export default "/app/global-wrapper-client/static/16dc30539e14fa6601b2555edfd26544.ttf";